import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Leave_register.api';


export const getLeaveRequest = () => ({
  type: actionTypes.GET_LEAVE_REGISTER_REQUEST,
});

export const getLeaveSuccess = (leave) => ({
  type: actionTypes.GET_LEAVE_REGISTER_SUCCESS,
  payload: leave,
});

export const getLeaveFailure = (error) => ({
  type: actionTypes.GET_LEAVE_REGISTER_FAILURE,
  payload: error,
});

export const getLeaveRegister = (date) => {
  return async (dispatch) => {
    dispatch(getLeaveRequest(date));
    try {
      const leaves = await api.fetchLeaveRegisterData(date);
      dispatch(getLeaveSuccess(leaves));
      console.log("leaves", leaves);

      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateLeaveRequest = (id, leaveData) => ({
  type: actionTypes.UPDATE_LEAVE_REGISTER_REQUEST,
  payload: { id, leaveData },
});

export const updateLeaveSuccess = (message) => ({
  type: actionTypes.UPDATE_LEAVE_REGISTER_SUCCESS,
  payload: message,
});

export const updateLeaveFailure = (error) => ({
  type: actionTypes.UPDATE_LEAVE_REGISTER_FAILURE,
  payload: error,
});

export const updateLeaveById = (id, leaveData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    leaveData.updated_by = user.user_name;

    dispatch(updateLeaveRequest(id, leaveData));
    try {
      const response = await api.updateLeaveRegister(id, leaveData);
      dispatch(updateLeaveSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};




export const deleteLeaveRequest = (id) => ({
  type: actionTypes.DELETE_LEAVE_REGISTER_REQUEST,
  payload: id,
});

export const deleteLeaveSuccess = (message) => ({
  type: actionTypes.DELETE_LEAVE_REGISTER_SUCCESS,
  payload: message,
});

export const deleteLeaveFailure = (error) => ({
  type: actionTypes.DELETE_LEAVE_REGISTER_FAILURE,
  payload: error,
});

export const deleteLeaveById = (id) => {
  return async (dispatch) => {
    dispatch(deleteLeaveRequest(id));
    try {
      const response = await api.deleteLeaveRegister(id);
      dispatch(deleteLeaveSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteLeaveFailure(error));
      return { success: false, message: error };
    }
  };
};


// export const uploadLeaveRegisterRequest = (fileData) => ({
//   type: actionTypes.UPLOAD_LEAVE_REGISTER_REQUEST,
//   payload: fileData,
// });

// export const uploadLeaveRegisterSuccess = (message) => ({
//   type: actionTypes.UPLOAD_LEAVE_REGISTER_SUCCESS,
//   payload: message,
// });

// export const uploadLeaveRegisterFailure = (error) => ({
//   type: actionTypes.UPLOAD_LEAVE_REGISTER_FAILURE,
//   payload: error,
// });

// export const uploadLeaveRegisterFile = (fileData) => {
//   return async (dispatch) => {
//     dispatch(uploadLeaveRegisterRequest(fileData));
//     try {
//       const response = await api.leaveRegisterUpload(fileData);
//       // showSnackbar(response, 'success');
//       dispatch(uploadLeaveRegisterSuccess(response));
//       console.log("leave response 01", response);
//       return { success: true, message: response };
//     } catch (error) {
//       dispatch(uploadLeaveRegisterFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };

export const uploadLeaveRegisterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_LEAVE_REGISTER_REQUEST,
  payload: fileData,
});

export const uploadLeaveRegisterSuccess = (message) => ({
  type: actionTypes.UPLOAD_LEAVE_REGISTER_SUCCESS,
  payload: message,
});

export const uploadLeaveRegisterFailure = (error) => ({
  type: actionTypes.UPLOAD_LEAVE_REGISTER_FAILURE,
  payload: error,
});

export const uploadLeaveRegisterFile = (fileData, targetMonth) => {
  return async (dispatch) => {
    dispatch(uploadLeaveRegisterRequest(fileData));
    try {
      const response = await api.leaveRegisterUpload(fileData, targetMonth);
      dispatch(uploadLeaveRegisterSuccess(response));
      console.log("leave response", response);
      
      // ✅ FIX: Return flattened response data directly
      return { 
        success: true, 
        message: response.data  // Extract .data here instead of in component
      };
      
    } catch (error) {
      dispatch(uploadLeaveRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};



export const multiDaleteLeaveRegisterRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_LEAVE_REGISTER_REQUEST,
  payload: ids,
});

export const multiDaleteLeaveRegisterSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_LEAVE_REGISTER_SUCCESS,
  payload: message,
});

export const multiDaleteLeaveRegisterFailure = (error) => ({
  type: actionTypes.MULTIDELETE_LEAVE_REGISTER_FAILURE,
  payload: error,
});

export const multiDeleteLeaveRegister = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteLeaveRegisterRequest(ids));
    try {
      const response = await api.multiDeleteLeaveRegister(ids);
      dispatch(multiDaleteLeaveRegisterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteLeaveRegisterFailure(error));
      return { success: false, message: error };
    }
  };
};
